<template>
  <b-modal
    v-model="modalVisible"
    title="استيراد ملف KML مجمع"
    hide-footer
    @hidden="$emit('hidden')"
  >
    <b-form-file
      v-model="localKmlImportFile"
      accept=".kml"
      :disabled="kmlImportLoading"
      :state="localKmlImportFile ? true : null"
      placeholder="اختر ملف KML"
      drop-placeholder="اسحب ملف KML هنا"
      browse-text="تصفح"
    />
    <div class="d-flex justify-content-end mt-2">
      <b-button
        variant="outline-secondary"
        class="ml-1"
        :disabled="kmlImportLoading"
        @click="modalVisible = false"
      >
        إلغاء
      </b-button>
      <b-button
        variant="primary"
        :disabled="kmlImportLoading || !localKmlImportFile"
        @click="$emit('submit')"
      >
        <b-spinner
          v-if="kmlImportLoading"
          small
          class="mr-1"
        />
        <span v-else>استيراد</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BFormFile, BButton, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'KmlImportModal',
  components: {
    BModal,
    BFormFile,
    BButton,
    BSpinner,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    kmlImportFile: {
      type: [File, Object, String, null],
      default: null,
    },
    kmlImportLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    localKmlImportFile: {
      get() {
        return this.kmlImportFile
      },
      set(val) {
        this.$emit('update:kmlImportFile', val)
      },
    },
  },
}
</script>
